import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'citySort',
    standalone: false
})
export class CitySortPipe implements PipeTransform {
  transform(inputList: any[], labelKey?: string): any[] {
    labelKey = labelKey ?? 'DisplayName';
    // Turkish alphabet with proper sorting order
    const alphabet = 'abcçdefgğhıijklmnoöpqrsştuüvwxyz';

    // Define a custom sorting function
    function turkishSort(a: any, b: any): number {
      // Check if label starts with "All "
      const labelA = a[labelKey].toLowerCase();
      const labelB = b[labelKey].toLowerCase();

      const isAllA = labelA.startsWith('all ') || labelA.startsWith('general.all');
      const isAllB = labelB.startsWith('all ') || labelB.startsWith('general.all');

      // Prioritize items starting with "All " to be at the top
      if (isAllA && !isAllB) {
        return -1;
      } else if (!isAllA && isAllB) {
        return 1;
      }

      // Extract the main text and the number at the end
      const regex = /^(.+?)(\d+)?$/;
      const matchA = labelA.match(regex);
      const matchB = labelB.match(regex);

      const mainTextA = matchA[1];
      const mainTextB = matchB[1];
      const numA = matchA[2] ? parseInt(matchA[2], 10) : null;
      const numB = matchB[2] ? parseInt(matchB[2], 10) : null;

      // Compare the alphabetical parts
      for (let i = 0; i < Math.min(mainTextA.length, mainTextB.length); i++) {
        const indexA = alphabet.indexOf(mainTextA[i]);
        const indexB = alphabet.indexOf(mainTextB[i]);
        if (indexA !== indexB) {
          return indexA - indexB;
        }
      }

      // If alphabetical parts are equal, compare numbers
      if (numA !== null && numB !== null) {
        return numA - numB;
      }

      // If one has a number and the other doesn't, the one without a number goes first
      if (numA !== null && numB === null) {
        return 1;
      } else if (numA === null && numB !== null) {
        return -1;
      }

      // If labels are completely equal up to this point, sort based on length
      return mainTextA.length - mainTextB.length;
    }

    // Sort the list using the custom sorting function
    return inputList.sort(turkishSort);
  }
}

